'use client';

import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';
import { SpinLoader, useTranslation } from '@weareconceptstudio/core';
import { usePageLoading } from '@/hooks/usePageLoading';
import PageLoadingOverlayStyle from './style';

const PageLoadingOverlay = () => {
	const { translate } = useTranslation();
	const { isPageLoading } = usePageLoading();
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted || !isPageLoading) return null;

	return createPortal(
		<PageLoadingOverlayStyle
			role='status'
			aria-live='polite'
			aria-busy='true'
			aria-label={translate('common.pageLoading')}>
			<SpinLoader />
		</PageLoadingOverlayStyle>,
		document.body
	);
};

export default PageLoadingOverlay;
